import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventReviewPage({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/EventReviewPage"));
  console.log("Loading", AsyncEventReviewPage.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventReviewPage;
